// extracted by mini-css-extract-plugin
export var errorsContainer = "_ty-1";
export var link = "_ty-0";